import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const OrientacoesNotificacao = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="ORIENTAÇÕES E NOTIFICAÇÕES" />
                    <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                </Caixa>
            )
        }
        return partes
    }
}

export default OrientacoesNotificacao